import { path } from 'ramda';

import { PAGES_STORE_KEY } from '@/redux/constants';

import { ENTITY_NAME } from './consts';

export const getItemsRoot = path([PAGES_STORE_KEY, ENTITY_NAME, 'items']);

export const getQuery = path([PAGES_STORE_KEY, ENTITY_NAME, 'query']);
